import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ICON_SIZE } from '../../design-system';
import './AIQuestionRow.css';

/** Shared question action for summary prompts and chat follow-ups. */
export default function AIQuestionRow({ question, onClick, disabled = false, className = '' }) {
  const { t } = useTranslation('reader');
  const Row = onClick ? 'button' : 'div';

  return (
    <Row
      className={`ai-question-row ${className}`.trim()}
      {...(onClick && {
        type: 'button',
        disabled,
        onClick,
        'aria-label': `${t('summary.askAI')}: ${question}`,
      })}
    >
      {onClick && <Sparkles size={ICON_SIZE.xs} className="ai-question-row-icon" aria-hidden="true" />}
      <span className="ai-question-row-text">{question}</span>
    </Row>
  );
}
